import { MButton } from '@Components/Base';
import classNames from 'classnames';

import { ReactComponent as PlusAddIcon } from '@Icons/additional/plus-gradient.svg';
import { ReactComponent as DeleteIcon } from '@Icons/additional/trash-gradient.svg';

import styles from './material-card.module.css';

interface MaterialCardProps {
  materialLabel: string;
  materialCode: string | number;
  materialDescription?: string;
  isAdded: boolean;
  isDisabled?: boolean;
  unit?: string | number;
  qty?: string | number;
  onAdd: () => void;
  onRemove: () => void;
}

const MaterialCard: React.FC<MaterialCardProps> = ({
  materialLabel,
  materialCode,
  materialDescription,
  isAdded,
  isDisabled = false,
  unit,
  qty,
  onAdd,
  onRemove,
}) => {
  const handleAddMaterial = (): void => {
    onAdd();
  };
  const handleRemoveMaterial = (): void => {
    onRemove();
  };

  return (
    <div
      className={classNames(
        styles.container,
        isAdded && styles.added,
        isDisabled && styles.disabled
      )}
    >
      <div className={styles.header}>
        <div className={styles.title} title={materialLabel}>
          {materialLabel}
        </div>
        {!isAdded ? (
          <MButton
            className={styles.button}
            type="text"
            onClick={handleAddMaterial}
          >
            <PlusAddIcon /> Add
          </MButton>
        ) : (
          <MButton
            className={styles.button}
            type="text"
            onClick={handleRemoveMaterial}
          >
            <DeleteIcon /> Remove
          </MButton>
        )}
      </div>
      <div className={styles.content}>
        <div className={styles.description}>
          <span className={styles.label}>Material Code</span>
          <span className={styles.value}>{materialCode}</span>
        </div>
        <div className={styles.description}>
          <span className={styles.label}>Material Description</span>
          <span className={styles.value} title={materialDescription}>
            {materialDescription}
          </span>
        </div>
        <div className={styles.description}>
          <span className={styles.label}>Unit</span>
          <span className={styles.value}>{unit}</span>
        </div>
        <div className={styles.description}>
          <span className={styles.label}>Qty.</span>
          <span className={styles.value}>{qty}</span>
        </div>
      </div>
    </div>
  );
};

export default MaterialCard;
